import TabPage from "./../factories/tab-page";
import "./../bindings/bao-upload";
import "./../bindings/bao-searcher";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import Guid from "./../factories/guid";
import BaoDialog from "./../factories/bao-dialog";
class UniversalImport {
    TabPage: TabPage;
    ImportTypeId: KnockoutObservable<string> = ko.observable();
    ImportTypeName: KnockoutObservable<string> = ko.observable();
    SelectedImportType: KnockoutObservable<any> = ko.observable();
    UploadedFileId = ko.observable();
    UploadedFileName: KnockoutObservable<string> = ko.observable();
    Message: KnockoutObservable<string> = ko.observable();
    disableBtnImport: KnockoutObservable<boolean> = ko.observable(false);
    ImportTypeSearcher: Bindings.baoSearcher = {
        SearchType: "ImportType",
        ObjectId: this.ImportTypeId,
        ObjectValue: "Name",
        SelectedItem: this.SelectedImportType,
        AutoComplete: true,
        AutoSearch: true
    };
    FileUpload: Bindings.baoUpload = {
        Url: ko.computed(() => { return "UniversalImport/UploadFile?fileId=" + this.UploadedFileId(); }),
        Upload: "UploadTemplate",
        PhotoButtonEnabled: false
    };
    constructor(tabPage: TabPage) {
        this.TabPage = tabPage;
        this.UploadedFileName.subscribe(() => {
            this.disableBtnImport(false);
        });
    }
    init(): JQueryPromise<void> {
        this.TabPage.IsLoading(true);
        this.getNewFileId(); //laden einer ersten FileId
        return this.getUniversalImportMetadata();
    }
    UploadTemplate = () => {
    };
    ImportTask() {
        if (this.completeCheck()) {
            this.TabPage.IsLoading(true);
            $.when(this.UploadTemplate()).then(() => this.validateTask());
        }
    }
    private getNewFileId() {
        let fileId = Guid();
        this.UploadedFileId(fileId);
        return fileId;
    }
    private getUniversalImportMetadata(): JQueryPromise<void> {
        return Bao.post("UniversalImport/GetUniversalImportMetadata").then(metadata => {
            this.TabPage.Title(metadata.TabTitle);
            this.TabPage.IsLoading(false);
        });
    }

    private validateTask(): JQueryPromise<void> {
        this.Message("");
        var _this = this;
        return Bao.post("UniversalImport/ValidateFileAndGetCountofRows", JSON.stringify({
            fileId: this.UploadedFileId(),
            importTypeKey: this.SelectedImportType().ImportTypeKey
        })).then(result => {
            if (result.Success) {
                var yesNoDialog = new BaoDialog(Bao.Session.ApplicationName, result.Message, "yesno");
                yesNoDialog.DialogResult.subscribe(function (result) {
                    if (result === true) {
                        _this.importTask();
                    }
                });
            } else {
                this.Message(result.Message);
            }
            this.TabPage.IsLoading(false);
        });
    }

    private importTask(): JQueryPromise<void> {
        this.Message("");
        return Bao.post("UniversalImport/ImportTask", JSON.stringify({
            fileId: this.UploadedFileId(),
            importTypeKey: this.SelectedImportType().ImportTypeKey
        })).then(result => {
            if (result.Success) {
                new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgSuccessfulImport"), "info");
                this.disableBtnImport(true);
            }
            else {
                this.Message(result.Message);
            }
            this.UploadedFileName("");
            this.getNewFileId(); //neue Id falls das nächste dokument hochgeladen wird?
            this.TabPage.IsLoading(false);
        });
    }
    private completeCheck(): boolean {
        let isComplete = !Bao.Utils.String.IsNullOrEmpty(this.ImportTypeId()) && !Bao.Utils.String.IsNullOrEmpty(this.UploadedFileName());
        if (!isComplete) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    }
}
export default UniversalImport;